import Tooltip from '../../../core/Tooltip';
import { DrillDown, Skill } from '../../../icons';
import {
  SkillsInfoIcon,
  SkillInfoPop,
  SkillAnimList,
} from './styled/KpiSkills.styled';

const SKILLSMAP = {
  drilldown: 'Subgráfico',
} as const;

const SKILLMAPDESC = {
  drilldown: 'Clique no gráfico para ver um detalhamento daquela categoria.',
} as const;

interface KpisSkillsProps {
  availableSkills: (keyof typeof SKILLSMAP)[];
}

const KpiSkills = ({
  availableSkills,
}: KpisSkillsProps) => (
  <>
    <SkillsInfoIcon
      className="skills-icons"
      as={Tooltip}
      direction="bottom-start"
      text={(
        <SkillInfoPop>
          {availableSkills.map((skill) => (
            <div key={`tooltip-${skill}`}>
              <DrillDown />
              <b>{`${SKILLSMAP[skill]}: `}</b>
              {SKILLMAPDESC[skill]}
            </div>
          ))}
        </SkillInfoPop>
      )}
    >
      <Skill />
    </SkillsInfoIcon>
    <SkillAnimList skills={availableSkills}>
      {availableSkills.map((skill) => (
        <div key={`list-${skill}`}>
          <DrillDown />
          {SKILLSMAP[skill]}
        </div>
      ))}
    </SkillAnimList>
  </>
);

export default KpiSkills;
